import React, { useState, useEffect } from "react";
export default function ImageWithFallback({ fallback, src,token, ...props }) {
  const [imgSrc, setImgSrc] = useState(src)
  const onError = () => setImgSrc(fallback)

  useEffect(() => {
    if (token) {
      const options = {
        headers: {
          'Authorization': 'Bearer '+token
        }
      };
      fetch(src, options)
        .then(res => res.blob())
        .then(blob => {
          setImgSrc(URL.createObjectURL(blob));
        }).catch(error=>{console.log(error); setImgSrc(fallback)});
    }
  }, [token]);



  return <img src={imgSrc ? imgSrc : fallback} onError={onError} {...props} alt={imgSrc} />
}